<script>
import {mapGetters} from 'vuex';
  export default {
       data() {
      return {
        userData: JSON.parse(localStorage.getItem("userData")),
      };
    },
    methods: {

      $Can(permissionName) {
        if(this.userData.role==="supermanager"){
          return true;
        }else{
            return localStorage.getItem("userPerms").includes(permissionName)?true:false;
        }      
      },
       $CanViewMenu(item) {
        if(this.userData.role==="supermanager"){
          return true;
        }else{
            if(item.requiresInfinaReport){
              return this.userData.infina_report == 1;
            }
            if(item.requiresIntesaReport){
              return this.userData.intesa_report == 1;
            }
            if(item.requiresAzimutReport){
              return this.userData.azimut_report == 1;
            }
            return this.$Can(item.Permission);
        }
      },
    },
    
  };
</script>